import { Controller } from '@hotwired/stimulus';

const COOKIE_NAME = 'last_visited_date';

export default class extends Controller {
  connect() {
    if (!this.shouldRecord()) return;

    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content');
    fetch('/member_last_visit', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-CSRF-Token': csrfToken }
    });
  }

  shouldRecord() {
    const recorded = this.readCookie(COOKIE_NAME);
    if (!recorded) return true;
    return recorded < this.todayIso();
  }

  readCookie(name) {
    const match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    return match ? match[1] : null;
  }

  todayIso() {
    const now = new Date();
    const y = now.getFullYear();
    const m = String(now.getMonth() + 1).padStart(2, '0');
    const d = String(now.getDate()).padStart(2, '0');
    return `${y}-${m}-${d}`;
  }
}
